maybeDeepFreeze